export default class PrimaryRoomView {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
        this.floor = json.floor;
        this.location = json.location;
    }
}
